export class AccessCardAdd {
  holderId?: number;
  accessCardTypeId: number;
  requestAccessCardReasonId: number;
  companyName: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  email: string;
  phone: string;
  startDate: Date;
  endDate?: Date;
}




// WEBPACK FOOTER //
// ./src/app/core/models/access-card-add.ts